import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LabTrendChart = ({ data, selectedTests }) => {
  const colors = ['#2563EB', '#059669', '#D97706', '#DC2626', '#0F766E'];

  return (
    <div className="w-full h-80 md:h-96 lg:h-[400px]" aria-label="Lab Results Trend Chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="date"
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend
            wrapperStyle={{
              fontSize: '12px',
              color: 'var(--color-foreground)'
            }}
          />
          {selectedTests?.map((test, index) => (
            <Line
              key={test}
              type="monotone"
              dataKey={test}
              stroke={colors?.[index % colors?.length]}
              strokeWidth={2}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LabTrendChart;